<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Penetapan & Pencetakan Massal</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <select class="form-control" v-model="tab">
                            <option>Penetapan Massal</option>
                            <option>Cetak Massal</option>
                        </select>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                
                <div v-if="tab == 'Penetapan Massal'">
                    <h3>Penetapan Massal</h3>
                    <bhumie_penetapan_pencetakan_massal_tab1></bhumie_penetapan_pencetakan_massal_tab1>
                </div>

                <div v-if="tab == 'Cetak Massal'">
                    <h3>Cetak Massal</h3>
                    <bhumie_penetapan_pencetakan_massal_tab2></bhumie_penetapan_pencetakan_massal_tab2>
                </div>


        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

const ADD_URL = URL_APP+'api/v1/kecamatan/';


export default {
  name: "monev_kabupaten",
  data() {
    return {
        tab: 'Penetapan Massal',
    };
  },

// =============================================================== METHODS =========================================================================
  methods : {


  },
// =============================================================== METHODS =========================================================================

  mounted() {
    localStorage.sidemenu = 'bhumie';
  },
};
</script>
